import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router, NavigationExtras, ActivatedRoute} from '@angular/router';
import { DatePipe } from '@angular/common';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { ChecklistFacade } from '../../../common/facade/ChecklistFacade';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
    selector: 'app-reportstore',
    templateUrl: './reportstore.component.html'
})

export class ReportStoreComponent
    implements OnInit {

    // Properties and Attributes

    lblDownload = res.Download;
    lblSearch = res.Search;
    lblStore = res.Store;
    lblExecutionDate = res.ExecutionDate;
    lblBrand = res.Brand;
    lblProgress = res.Progress;
    lblStatus = res.Status;
    lblNewActions = res.NewActions;
    messagesTable: any = {
        emptyMessage: '',
        totalMessage: ''
    };
    isSpanish = true;

    @ViewChild('tableActivities') tableActivities: DatatableComponent;
    TitleActivity = '';
    Loading = false;
    MessageLoader = '';
    message = '';
    modalTitle = '';
    rows: any = [];
    reportExcel: any = [];
    public _catDetTaskTypeId = 0;
    public rptActivPath = 'views/task/report';
    public rptActivExtras: NavigationExtras;
    private _filteredData = [];
    private _activityCode = '';
    private _requiredDate = '';
    private _taskId = 0;

    // alert
    alerts: any[] = [];
    _organizations = '';
    orgId: string;

    // Constructor
    constructor(
        private _facade: ActivityStoreFacade,
        private _checklistFacade: ChecklistFacade,
        private _route: ActivatedRoute,
        private _router: Router,
        private _datePipe: DatePipe,
        private _excel: ExcelUtility,
        public strings: Strings,
        private localeService: BsLocaleService
    ) {
    }

    // EventHandlers
    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();
        this.localeService.use(this.strings.getLanguage());
        
        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        this._route.queryParams.subscribe(params => {
            this._activityCode = params['pCd'];
            this._catDetTaskTypeId = Number(params['pCtDtTskTypd']);
            this._requiredDate = params['pRqrd'];
            this._organizations = params['pOrgs'];
            this._taskId = params['pTi'];
            this.orgId = params['orgId'];
            this.rptActivExtras = {
                queryParams: {
                    'pCtDtTskTypd': this._catDetTaskTypeId
                    , 'pOrgs': this._organizations
                    , 'orgId': this.orgId
                    , 'pTi': this._taskId
                }
            };
          });

        this.Loading = true;
        this.MessageLoader = this.strings.GetText(res.LoadingInfo);
        let language = 0;
        if (!this.isSpanish) {
            language = 1;
        }
        this._facade.GetReport(this._activityCode, this._requiredDate, language, this._organizations).subscribe(result => {
            if (result.completed) {
                const reqDate = new Date(Number(this._requiredDate.substr(0, 4)),
                                   Number(this._requiredDate.substr(4, 2)) - 1,
                                   Number(this._requiredDate.substr(6, 2)));
                if (this.isSpanish) {
                    this.TitleActivity = result.message + ' ' + this._datePipe.transform(reqDate, 'dd/MM/yyyy');
                } else {
                    this.TitleActivity = result.message + ' ' + this._datePipe.transform(reqDate, 'MM/dd/yyyy');
                }
                this.rows = result.data;
                this._filteredData = result.data;
            }
            this.Loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.Loading = false;
        });
    }

    onViewDetail(activStoreId: any) {
        let routeTo = '';
        const item = this.rows.find(x => x.activStoreId === activStoreId);
        const navigationExtras: NavigationExtras = {
            queryParams: {
              'pActvStrd': item.activStoreId,
              'pStoreName': item.storeName,
              'pTitleActivity' : this.TitleActivity,
              'pCtDtTskType' : this._catDetTaskTypeId,
              'pTi': this._taskId,
              'pSi': item.storeId
            }
          };

        if (this._catDetTaskTypeId == 101) {
            routeTo = 'views/task/report/store/pricechange';
        } else {
            routeTo = 'views/task/report/store/instruction';
        }

        this._router.navigate([routeTo], navigationExtras).then( (e) => {
            if (e) {
              console.log('Navigation is successful!');
            } else {
              console.log('Navigation has failed!');
            }
          });

    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();

        const keys = Object.keys(this._filteredData[0]);
        this.rows = this._filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });

        this.tableActivities.offset = 0;
    }

    goBack() {
        window.history.back();
    }

    // añadir alert
    addAlert(message: String, type: String): void {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    downloadLayout() {
        this.Loading = true;
        this.MessageLoader = 'Obteniendo reporte';

        this._checklistFacade.GetInstructionInventory(parseInt(this._activityCode)).subscribe(result => {
            if (result.completed) {
                const data: any = [];

                result.data.forEach(row => {
                    const info = <any>{};
                    info.Grupo = row.checklistSections[0].title;
                    info.Producto = row.title;
                    row.activityStoreInstructions.forEach(instruction => {
                        info['T-' + instruction.storeId.toString()] = instruction.answerText;
                    });
                    data.push(info);
                });

                this.reportExcel = data;

                if (this.reportExcel.length > 0) {
                    this._excel.exportAsExcelFile(this.reportExcel, this.TitleActivity);
                } else {
                    this.addAlert(this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
                }
            } else {
                this.addAlert(this.strings.GetText(res.AlertCannotGenerateReport) + result.message, 'danger');
            }

            this.Loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.Loading = false;
        });
    }

}
